import React from "react";

export function RobotIcon({ size = 28, animated = false }) {
  const scale = size / 28;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28 28"
      width={size}
      height={size}
      fill="none"
      className={animated ? "robot-icon robot-icon--animated" : "robot-icon"}
      aria-hidden="true"
    >
      <line x1="14" y1="2" x2="14" y2="6" stroke="currentColor" strokeWidth={1.5 / scale} strokeLinecap="round" />
      <circle cx="14" cy="2" r={1.2 / scale} fill="currentColor" />
      <rect x="5" y="6" width="18" height="13" rx={2.5 / scale} stroke="currentColor" strokeWidth={1.5 / scale} fill="none" />
      <circle cx="10" cy="12" r={1.8 / scale} fill="currentColor" className={animated ? "robot-eye" : ""} />
      <circle cx="18" cy="12" r={1.8 / scale} fill="currentColor" className={animated ? "robot-eye" : ""} />
      <path d="M10.5 16.5 Q14 18.5 17.5 16.5" stroke="currentColor" strokeWidth={1.5 / scale} strokeLinecap="round" fill="none" />
      <rect x="9" y="19" width="10" height="7" rx={1.5 / scale} stroke="currentColor" strokeWidth={1.5 / scale} fill="none" />
      <line x1="5" y1="21" x2="9" y2="21" stroke="currentColor" strokeWidth={1.5 / scale} strokeLinecap="round" />
      <line x1="19" y1="21" x2="23" y2="21" stroke="currentColor" strokeWidth={1.5 / scale} strokeLinecap="round" />
    </svg>
  );
}

export function AgentIcon({ size = 28 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M12 2a5 5 0 1 0 5 5 5 5 0 0 0-5-5z" />
      <path d="M20 21a8 8 0 1 0-16 0" />
      <circle cx="18" cy="18" r="4" fill="none" />
      <path d="M16.5 18.5l1 1 2-2" />
    </svg>
  );
}

export function TrashIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
      <path d="M10 11v6M14 11v6" />
      <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
    </svg>
  );
}

export function TypingDots() {
  const { useTranslation } = require("react-i18next");
  const { t } = useTranslation();

  return (
    <span className="ai-typing-dots" aria-label={t("Escribiendo...")}>
      <span /><span /><span />
    </span>
  );
}
